import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import {
  BI_REPORTS,
  CANCELED_STATUS,
  COMPLETED_STATUS,
  PENDING_STATUS,
  REPORT_TYPES,
} from '../../constants'
import { groupBy } from '../../helper'
import { getDetailOrderThunk, postCancelOrder } from './thunk'
const { createSlice } = require('@reduxjs/toolkit')

const slice = createSlice({
  name: 'userManagement/subscriptionPayment/orderManagement/orderDetail',
  initialState: {
    isLoading: true,
    data: {},
    factSheetIds: [],
    factSheet: {},
    creditIds: [],
    credit: {},
    standardIds: [],
    standard: {},
    comprehensiveIds: [],
    comprehensive: {},
    bIReportIds: [],
    bIReport: {},
    screeningIds: [],
    screening: {},
    internationalReportIds: [],
    internationalReport: {},
    conciergeServiceIds: [],
    conciergeService: {},
    screeningData: [],
    factSheetData: [],
    reportBIData: [],
    internationalData: [],
    conciergeData: [],
    activeReport: BI_REPORTS.ALL,
    volume: {
      quantity: 0,
      isScreening: false,
    },
    isContainFactSheetAndBI: false,
    orderDetailStatus: {
      isAllNotCompleted: false,
      isAllPending: false,
      isCancelled: false,
    },
    isCancelSuccessfully: false,
    details: [],
  },
  reducers: {
    changeActiveReport: (state, { payload = {} }) => {
      state.activeReport = payload
    },
    changeQuantity: (state, { payload }) => {
      state.quantity = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDetailOrderThunk.pending, (state) => {
        state.isLoading = true
        state.transactionStatus = []
      })
      .addCase(getDetailOrderThunk.fulfilled, (state, { payload = {} }) => {
        state.isLoading = false
        const { details = [], ...rest } = payload
        let quantity = 0

        const numberOfCompanies = details
          .map((item) => item?.numOfCompanies)
          .reduce((curr, next) => curr + next, 0)

        state.data = rest
        state.details = details
        const groupDetails = groupBy(details, 'fiinGateReportTypeId')

        const allStatusDetails = Object.values(groupDetails)?.map(
          (item) => item.map((item) => item.status)[0],
        )
        state.orderDetailStatus.isAllNotCompleted = allStatusDetails?.every(
          (item) => item !== COMPLETED_STATUS,
        )
        state.orderDetailStatus.isAllPending = allStatusDetails?.every(
          (item) => item === PENDING_STATUS,
        )
        state.orderDetailStatus.isCancelled = allStatusDetails?.every(
          (item) => item === CANCELED_STATUS,
        )

        // FactSheet
        const factSheets = groupDetails[REPORT_TYPES.FACT_SHEET] || []
        const factSheetsWithId = factSheets.map((item, index) => ({
          ...item,
          orderDetailId: item.id,
          id: index + 1,
          paymentMethod: rest.paymentMethod,
        }))
        state.factSheetIds = factSheetsWithId.map((item) => item.id)
        const dataFormatDateFactSheet = factSheetsWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.factSheet = keyBy(dataFormatDateFactSheet, 'id')
        quantity += factSheets.length
        state.factSheetData = factSheetsWithId

        // Credit
        const credits = groupDetails[REPORT_TYPES.CREDIT] || []
        const creditsWithId = credits.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
        state.creditIds = creditsWithId.map((item) => item.id)
        const dataFormatDateCredit = creditsWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.credit = keyBy(dataFormatDateCredit, 'id')

        // Standard
        const standards = groupDetails[REPORT_TYPES.STANDARD] || []
        const standardsWithId = standards.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
        state.standardIds = standardsWithId.map((item) => item.id)
        const dataFormatDateStandard = standardsWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.standard = keyBy(dataFormatDateStandard, 'id')

        // Comprehensive
        const comprehensives = groupDetails[REPORT_TYPES.COMPREHENSIVE] || []
        const comprehensivesWithId = comprehensives.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
        state.comprehensiveIds = comprehensivesWithId.map((item) => item.id)
        const dataFormatComprehensive = comprehensivesWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.comprehensive = keyBy(dataFormatComprehensive, 'id')

        // Business Report
        const bIReports = [...credits, ...standards, ...comprehensives]
        const bIReportsWithId = bIReports.map((item, index) => ({
          ...item,
          orderDetailId: item.id,
          id: index + 1,
          paymentMethod: rest.paymentMethod,
        }))

        state.bIReportIds = bIReportsWithId.map((item) => item.id)
        const dataFormatBl = bIReportsWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.bIReport = keyBy(dataFormatBl, 'id')
        quantity += bIReports.length
        state.reportBIData = bIReportsWithId

        // Screening
        const screenings = groupDetails[REPORT_TYPES.SCREENING] || []
        const screeningsWithId = screenings.map((item, index) => ({
          ...item,
          orderDetailId: item.id,
          id: index + 1,
          paymentMethod: rest.paymentMethod,
        }))
        state.screeningIds = screeningsWithId.map((item) => item.id)
        const dataFormatDateScreening = screeningsWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.screening = keyBy(dataFormatDateScreening, 'id')
        state.screeningData = screeningsWithId
        if (!!screenings.length) {
          quantity = numberOfCompanies
        }

        // International
        const international =
          groupDetails[REPORT_TYPES.INTERNATIONAL_REPORT] || []
        const internationalWithId = international.map((item, index) => ({
          ...item,
          orderDetailId: item.id,
          id: index + 1,
          paymentMethod: rest.paymentMethod,
        }))
        state.internationalReportIds = internationalWithId.map(
          (item) => item.id,
        )
        const dataFormatDateInternational = internationalWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.internationalReport = keyBy(dataFormatDateInternational, 'id')
        quantity += international.length
        state.internationalData = internationalWithId

        // Concierge Service
        const businessConcierge =
          groupDetails[REPORT_TYPES.BUSINESS_CONCIERGE] || []
        const businessConciergeWithId = businessConcierge.map(
          (item, index) => ({
            ...item,
            orderDetailId: item.id,
            id: index + 1,
            paymentMethod: rest.paymentMethod,
          }),
        )
        state.conciergeServiceIds = businessConciergeWithId.map(
          (item) => item.id,
        )
        const dataFormatDateConcierge = businessConciergeWithId.map((item) => ({
          ...item,
          expectedDeliveryDate: item?.deliveryDate
            ? item?.deliveryDate
            : item?.expectedDeliveryDate,
        }))
        state.conciergeService = keyBy(dataFormatDateConcierge, 'id')
        quantity += businessConcierge.length
        state.conciergeData = businessConciergeWithId

        state.volume.quantity = quantity
        state.volume.isScreening = screenings.length

        if (!!bIReportsWithId.length && !!factSheetsWithId.length) {
          state.isContainFactSheetAndBI = true
        } else {
          state.isContainFactSheetAndBI = false
        }

        state.isCancelSuccessfully = false
      })
      .addCase(getDetailOrderThunk.rejected, (state, { payload = {} }) => {
        state.isLoading = payload.isLoading
      })

    builder.addCase(postCancelOrder.fulfilled, (state) => {
      state.isCancelSuccessfully = true
    })
  },
})

register(slice.name, slice.reducer)

export const { changeActiveReport, changeQuantity } = slice.actions

export const selectData = (state) => state[slice.name].data
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectFactSheetIds = (state) => state[slice.name].factSheetIds
export const selectFactSheetCellData = (rowId, colId) => (state) =>
  state[slice.name].factSheet[rowId][colId]
export const selectCreditIds = (state) => state[slice.name].creditIds
export const selectCreditCellData = (rowId, colId) => (state) =>
  state[slice.name].credit[rowId][colId]
export const selectStandardIds = (state) => state[slice.name].standardIds
export const selectStandardCellData = (rowId, colId) => (state) =>
  state[slice.name].standard[rowId][colId]
export const selectComprehensiveIds = (state) =>
  state[slice.name].comprehensiveIds
export const selectComprehensiveCellData = (rowId, colId) => (state) =>
  state[slice.name].comprehensive[rowId][colId]
export const selectBIReportIds = (state) => state[slice.name].bIReportIds
export const selectBIReportCellData = (rowId, colId) => (state) =>
  state[slice.name].bIReport[rowId][colId]
export const selectScreeningIds = (state) => state[slice.name].screeningIds
export const selectScreeningCellData = (rowId, colId) => (state) =>
  state[slice.name].screening[rowId][colId]
export const selectInternationalReportIds = (state) =>
  state[slice.name].internationalReportIds
export const selectInternationalReportCellData = (rowId, colId) => (state) =>
  state[slice.name].internationalReport[rowId][colId]
export const selectConciergeServiceIds = (state) =>
  state[slice.name].conciergeServiceIds
export const selectConciergeServiceCellData = (rowId, colId) => (state) =>
  state[slice.name].conciergeService[rowId][colId]
export const selectScreeningData = (state) => state[slice.name].screeningData
export const selectFactSheetData = (state) => state[slice.name].factSheetData
export const selectReportBIData = (state) => state[slice.name].reportBIData
export const selectInternationalReportData = (state) =>
  state[slice.name].internationalData
export const selectConciergeServiceData = (state) =>
  state[slice.name].conciergeData
export const selectActiveReport = (state) => state[slice.name].activeReport
export const selectVolume = (state) => state[slice.name].volume
export const selectIsContainFactSheetAndBI = (state) =>
  state[slice.name].isContainFactSheetAndBI
export const selectOrderDetailStatus = (state) =>
  state[slice.name].orderDetailStatus
export const selectIsCancelSuccessfully = (state) =>
  state[slice.name].isCancelSuccessfully
export const selectDetails = (state) => state[slice.name].details
